<template>
	<section>
		<div class="card">
			<b-overlay :show="loading" rounded="sm" no-wrap></b-overlay>
			<div class="card-header p-2 text-center">
				<span class="font-weight-bold"><md-icon icon="directions_car"></md-icon> {{$t("dashboard.driverPerformance")}}</span>
			</div>
			<div class="card-body p-1 mt-3">
				<b-table
				striped
				hover
				:items="items"
				:fields="fields"
				:per-page="pag.perPage"
				:current-page="pag.currentPage"
				show-empty
				:empty-text="$t('global.ajaxTable.noRecordsFound')"
				stacked="md"

				>
					<template #cell(name)="row">
						{{getFullName(row.item)}}
					</template>
				</b-table>
				<b-pagination v-model="pag.currentPage" :total-rows="pag.totalRows" :per-page="pag.perPage" class="float-right"></b-pagination>
			</div>
		</div>
	</section>
</template>
<script>
export default {
	props: {
		filters: {
			type : Object,
			required: true
		},
		triggerSearch:{
			type : Number,
			required: true
		}
	},
	data() {
		return {
			loading:false,
			codeReport:"drivers-performance",
			items:[],
			fields:[
				{key:'name',label:this.$t("users.name")},
				{key:'done',label:this.$t("transportServiceStatus.done")},
				{key:'noShow',label:this.$t("transportServiceStatus.noShow")},
				{key:'na',label:this.$t("transportServiceStatus.noProvided")},
				{key:'driverApp',label:'Driver app'}
			],
			pag:{
				currentPage:1,
				totalRows:0,
				perPage:5
			}
		}
	},
	methods: {
		ucfirst(string) {
			if (typeof string !== 'string') {
				return '';
			}

			return string.charAt(0).toUpperCase() + string.slice(1);
		},
		fetchData(){
			this.pag.currentPage=1;
			this.loading = true;
			this.$root.api.get(`/dashboard/charts/${this.codeReport}`,{params: {filters:this.filters}})
			.then((res) => {
				this.items = res.data;
				this.pag.totalRows = this.items.length;
			})
			.catch(this.$root.handleRequestError)
			.finally(()=>this.loading=false)
		},
		getFullName(item){
			return this.ucfirst(item.firstName.toLowerCase())+" "+this.ucfirst(item.lastName.toLowerCase())
		}
	},
	computed:{
	},
	mounted(){
		this.fetchData();//realiza la busqueda
	},
	watch:{
		triggerSearch(){//este valor es reactivo, el padre decide en que momento se dispara la busqueda
			this.fetchData();
		}
	},
};
</script>

